module.exports = __webpack_public_path__ + "img/fruit.bc20001f.png";